import { Checkbox } from './checkbox.component';

export * from './checkbox.component';
export default Checkbox;

Checkbox.define('der-ui-checkbox');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-checkbox': Checkbox;
    }
}
